// 외부 시스템 알림(전자결재 등) 표시 공용 — 알림함 목록 행(ActivityPanel.SystemRow)과
// 봇 대화 카드(SystemNoticeCard)가 같은 아이콘·링크 표기를 쓰도록 한 곳에 둔다.
import { Bell, CalendarClock, FileCheck, type LucideIcon } from 'lucide-react';

// 출처별 아이콘 — 모르는 출처는 벨. 색은 분류색(blue) — 브랜드 레드는 액션·경고 전용
const SOURCE_ICON: Record<string, LucideIcon> = {
  approval: FileCheck,
  calendar: CalendarClock,
};

export function sourceIconOf(source?: string | null): LucideIcon {
  return (source && SOURCE_ICON[source]) || Bell;
}

/** 링크는 원점까지만 보여 준다(문서 경로·id를 화면에 드러내지 않는다). 파싱 실패면 null */
export function linkOrigin(link?: string | null): string | null {
  if (!link) return null;
  try {
    const u = new URL(link);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.origin : null;
  } catch {
    return null;
  }
}

/** 알림함 탭 키가 외부 시스템 출처인가 ('all'·'people'은 탭 예약어 — server/config/integrations.js) */
export function isSystemSourceTab(tab?: string | null): tab is string {
  return !!tab && tab !== 'all' && tab !== 'people';
}
